export const CIAN_MF_UI_ELEMENT_NAME = 'cian-mf-ui';
